import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import LikeButton from "./Buttons/LikeButton";
import CommentButton from "./Buttons/CommentButton";
import MoreButton from "./Buttons/MoreButton";
import { CommnetComponentsType } from "types/main";
import { TYPO } from "styles/Typo";

function DebateButtons({
  data,
  type,
  setMode,
}: {
  data: CommentItem;
  type: CommnetComponentsType;
  setMode: (mode: "read" | "edit") => void;
}) {
  return (
    <div className="flex  h-[32px] items-center justify-between">
      <div className="flex items-center gap-5">
        <LikeButton data={data} type={type} />
        <CommentButton data={data} type={type} />
      </div>
      <div className="flex gap-2 items-center">
        {type === "optionDetail" && (
          <span
            className={`${TYPO.TYPO8_RG} text-gray40`}
          >{`조회 ${data?.view_count}회`}</span>
        )}
        <MoreButton data={data} type={type} setMode={setMode} />
      </div>
    </div>
  );
}

export default DebateButtons;
